import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {},
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

// Fetch Top Board
export const getTopBoard = createAsyncThunk(
  "billing/top-board",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/bill-top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch Payment Top Board
export const getPaymentTopBoard = createAsyncThunk(
  "billing/payment-top-board",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/payment-top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch Payout Top Board
export const getPayoutTopBoard = createAsyncThunk(
  "billing/payout-top-board",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/payout-top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get All Billing
export const getAllBilling = createAsyncThunk(
  "admin/all-billing",
  async (
    { page, rowsPerPage, name, status },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      const response = await axios.get(
        `/admin/campaign-bill?${params}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Billing By ID
export const getBillingById = createAsyncThunk(
  "admin/billing-by-id",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign-billing/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Update Bill Status
export const updateBillStatus = createAsyncThunk(
  "admin/update-bill-status",
  async (formData, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(
        `/admin/campaign-billing/status/`,
        formData,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Invoice
export const getInvoices = createAsyncThunk(
  "admin/all-invoice",
  async (
    { page, rowsPerPage, name, status },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      const response = await axios.get(
        `/admin/advertiser-billings?${params}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Payout
export const getPayout = createAsyncThunk(
  "admin/all-payout",
  async (
    { page, rowsPerPage, name, status },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      const response = await axios.get(
        `/admin/publisher-billings?${params}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Export advertiser payments
export const exportAdvertiserPayments = createAsyncThunk(
  "admin/export-advertiser-payments",
  async ({ startDate, endDate }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const params = new URLSearchParams({
        exportData: "true",
        exportType: "csv",
        startDate,
        endDate,
      });
      const response = await axios.get(
        `/admin/all-advertiser-report?${params.toString()}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Export publisher payouts
export const exportPublisherPayouts = createAsyncThunk(
  "admin/export-publisher-payouts",
  async ({ startDate, endDate }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const params = new URLSearchParams({
        exportData: "true",
        exportType: "csv",
        startDate,
        endDate,
      });
      const response = await axios.get(
        `/admin/publishers-report?${params.toString()}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Make Payment
export const makePayment = createAsyncThunk(
  "admin/make-payment",
  async (form, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post("/admin/make-bill-payment", form, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Billing Payments
export const getPayments = createAsyncThunk(
  "admin/billing-payments",
  async (
    { page, rowsPerPage, name, status, partyType },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      if (partyType) {
        params += `&partyType=${encodeURIComponent(partyType)}`;
      }
      const response = await axios.get(
        `/admin/billing-payments?${params}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Create Account Details
export const createAccountDetails = createAsyncThunk(
  "admin/create-account-details",
  async (formData, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post(`/admin/company-account`, formData, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
//Get Account Details
export const getAccountDetails = createAsyncThunk(
  "admin/account-details",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/campaign/company-account`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
)

const billingSlice = createSlice({
  name: "billing",
  initialState: {
    loading: false,
    topBoard: {},
    paymentTopBoard: {},
    payoutTopBoard: {},
    billings: [],
    billing: {},
    invoices: [],
    payouts: [],
    payments: [],
    accountDetails: {},
    meta: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get-top-board
      .addCase(getTopBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTopBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.topBoard = action.payload.data;
      })
      .addCase(getTopBoard.rejected, (state) => {
        state.loading = false;
      })
      // get-payment-top-board
      .addCase(getPaymentTopBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPaymentTopBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentTopBoard = action.payload.data;
      })
      .addCase(getPaymentTopBoard.rejected, (state) => {
        state.loading = false;
      })
      // get-payout-top-board
      .addCase(getPayoutTopBoard.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPayoutTopBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.payoutTopBoard = action.payload.data;
      })
      .addCase(getPayoutTopBoard.rejected, (state) => {
        state.loading = false;
      })
      // get-all-billing
      .addCase(getAllBilling.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.billings = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getAllBilling.rejected, (state) => {
        state.loading = false;
      })
      // get-billing-by-id
      .addCase(getBillingById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBillingById.fulfilled, (state, action) => {
        state.loading = false;
        state.billing = action.payload.data;
      })
      .addCase(getBillingById.rejected, (state) => {
        state.loading = false;
      })
      // update-bill-status
      .addCase(updateBillStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBillStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBillStatus.rejected, (state) => {
        state.loading = false;
      })
      // get invoices
      .addCase(getInvoices.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getInvoices.rejected, (state) => {
        state.loading = false;
      })
      // get payout
      .addCase(getPayout.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPayout.fulfilled, (state, action) => {
        state.loading = false;
        state.payouts = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getPayout.rejected, (state) => {
        state.loading = false;
      })
      // make payment
      .addCase(makePayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(makePayment.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(makePayment.rejected, (state) => {
        state.loading = false;
      })
      // get payments
      .addCase(getPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getPayments.rejected, (state) => {
        state.loading = false;
      })
      // create account details
      .addCase(createAccountDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAccountDetails.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createAccountDetails.rejected, (state) => {
        state.loading = false;
      })
      // get account details
      .addCase(getAccountDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAccountDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.accountDetails = action.payload.data;
      })
      .addCase(getAccountDetails.rejected, (state) => {
        state.loading = false;
      })
  },
});

export default billingSlice.reducer;
